import { gql } from '@apollo/client'
import { IMAGES } from './IMAGES';

export const HIGHLIGHT_CARD = gql`
  fragment highlightCard on  highlightCard_Entry {
    id
    title
    subTitle
    image {
      ${IMAGES('verticalCard')}
    }
    linkTitle
    ctaUrl {
      type
      uri
      url
    }
  }
`;
